/** @format */

export * from './global-chips.module';
